import * as actionTypes from '../config/actionTypes';

import * as formStates from './formStates';

const initialState = {
  loading: false,
  error: null,
  searchCriteriaForm: formStates.searchCriteriaForm,
  searchIDForm: formStates.searchIDForm,
  searchNameForm: formStates.searchNameForm,
  searchResults: null,

  actionLoading: false,
  actionMessage: null,
  saved: null,

  selectedValues: {},
};


const toggleLoadingReducer = (state) => {
  return {
    ...state,
    loading: !state.loading,
  };
};


const showErrorReducer = (state, payload) => {
  return {
    ...state,
    error: payload,
  };
};


const unMountReducer = () => {
  return {
    ...initialState,
  };
};


const updateSearchInputsReducer = (state, payload) => {
  return {
    ...state,
    [payload.section]: {
      ...state[payload.section],
      ...payload.data,
    },
  };
};


const showResultsReducer = (state, payload) => {
  return {
    ...state,
    searchResults: payload,
  };
};


const actionLoadingReducer = (state) => {
  return {
    ...state,
    actionLoading: !state.actionLoading,
  };
};


const actionMessageReducer = (state, payload) => {
  return {
    ...state,
    actionMessage: payload,
  };
};


const showSavedReducer = (state, payload) => {
  return {
    ...state,
    saved: payload,
  };
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_SEARCH_LOADING: return toggleLoadingReducer(state);
    case actionTypes.SHOW_SEARCH_ERROR: return showErrorReducer(state, action.payload);
    case actionTypes.UNMOUNT_SEARCH: return unMountReducer();
    case actionTypes.UPDATE_SEARCH_INPUTS: return updateSearchInputsReducer(state, action.payload);
    case actionTypes.SHOW_SEARCH_RESULTS: return showResultsReducer(state, action.payload);
    case actionTypes.SEARCH_ACTION_LOADING: return actionLoadingReducer(state);
    case actionTypes.SEARCH_ACTION_MESSAGE: return actionMessageReducer(state, action.payload);
    case actionTypes.SHOW_SAVED: return showSavedReducer(state, action.payload);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/search/reducers.js